<body class="graf img-fluid" #graf></body>

<div style="display: none">
  <ngx-uplot></ngx-uplot>
</div>

 